import type { FC } from "react";

import { MDSCardSlotName } from "@/mds";
import type { InviteSummary } from "@/pages/invites/invite.utils";
import { CardContainer, ModalCard, Stack } from "./shared";
import { InviteReadyAcceptedView } from "./invite-ready-accepted-view";
import { InviteReadyPendingView } from "./invite-ready-pending-view";
import {
  getInviteAcceptedMessage,
  getInviteDescription,
  getInviteSharedItemKindLabel,
  getInviteViewerGreeting,
} from "@/pages/invites/invites-page.utils";

interface InviteReadyViewProps {
  invite: InviteSummary;
  hasAccepted: boolean;
  isAccepting: boolean;
  acceptError: string | null;
  successMessage: string | null | undefined;
  viewerName: string | null;
  onAccept: () => void;
  onOpen?: () => void;
}

export const InviteReadyView: FC<InviteReadyViewProps> = ({
  invite,
  hasAccepted,
  isAccepting,
  acceptError,
  successMessage,
  viewerName,
  onAccept,
  onOpen,
}) => {
  const sharedItemKindLabel = getInviteSharedItemKindLabel({
    sharedItemKind: invite.sharedItemKind,
  });
  const viewerGreeting = getInviteViewerGreeting({ viewerName });
  const description = getInviteDescription({ invite });
  const acceptedMessage = getInviteAcceptedMessage({ invite, overrideMessage: successMessage });

  return (
    <CardContainer>
      <ModalCard title={viewerGreeting} description={description}>
        <div slot={MDSCardSlotName.Content}>
          <Stack spacing={24}>
            {hasAccepted ? (
              <InviteReadyAcceptedView
                message={acceptedMessage}
                sharedItemKindLabel={sharedItemKindLabel}
                onOpen={onOpen}
              />
            ) : (
              <InviteReadyPendingView
                onAccept={onAccept}
                isAccepting={isAccepting}
                acceptError={acceptError}
              />
            )}
          </Stack>
        </div>
      </ModalCard>
    </CardContainer>
  );
};
